export enum EmbellishmentType {
  DigitalPrint = "digital-print",
  ScreenPrint = "screen-print",
  Embroidery = "embroidery",
  HeatTransfer = "heat-transfer",
  DTF = "DTF"
}
